<template>
  <b-modal
    :id="$attrs.id"
    :busy="busy"
    :hide-header-close="true"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :title="title"
    :ok-title="$t('orders.complete')"
    size="sm"
    centered
    ok-variant="success"
    @hide="$emit('hide')"
    @ok="onConfirm"
    @show="onShow"
  >
    <b-form-group :label="$t('orders.payment_method')">
      <b-select
        v-model="inputMethod"
        :options="paymentOptions"
        :disabled="busy"
      ></b-select>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: 'OrderCompleteModal',
  props: {
    title: {
      type: String,
      default: 'Complete Order',
    },
    busy: {
      type: Boolean,
      default: false,
    },
    paymentMethods: {
      type: Array,
      required: true,
    },
    selectedMethod: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      inputMethod: null,
    };
  },

  computed: {
    paymentOptions() {
      return this.paymentMethods.map((method) => ({
        value: method,
        text: this.$t(`enums.payment_method.${method}`),
      }));
    },
  },

  methods: {
    onConfirm(modal) {
      modal.preventDefault()
      this.$emit('confirm', this.inputMethod);
    },

    onShow() {
      this.inputMethod = this.selectedMethod;
    },
  },
};

</script>
